/**
 * Prospective Slider — view.js
 * Initialises Swiper on every .prospective-swiper element.
 * Swiper is loaded globally (CDN) via the theme's enqueue_scripts hook.
 */

function initProspectiveSliders() {
	if ( typeof window.Swiper === "undefined" ) return;

	document
		.querySelectorAll( ".prospective-swiper:not(.swiper-initialized)" )
		.forEach( ( el ) => {
			const section = el.closest( ".prospective-slider-section" );
			if ( ! section ) return;

			new window.Swiper( el, {
				loop:          true,
				slidesPerView: 1,
				speed:         500,
				navigation: {
					prevEl:          section.querySelector( ".prospective-prev" ),
					nextEl:          section.querySelector( ".prospective-next" ),
					disabledClass:   "prospective-arrow-disabled",
				},
			} );
		} );
}

if ( document.readyState === "loading" ) {
	document.addEventListener( "DOMContentLoaded", initProspectiveSliders );
} else {
	initProspectiveSliders();
}
